module.exports = __webpack_public_path__ + "img/porte-service.3564c4c.svg";